/**
 * ============================================================================
 * MIGRATED FILE — DO NOT EDIT
 * ============================================================================
 *
 * This file has been migrated to academy-content-ui.
 * Canonical source: academy-content-ui/static/js/features/interactiveEducation/components/CompanionFooter.tsx
 *
 * This .migrated copy is retained only for LearningCenterUI consumers that
 * have not yet moved to academy-content-ui. All changes should be made in
 * academy-content-ui first, then synced here if still needed.
 *
 * This copy will be deleted when LearningCenterUI is shut down.
 *
 * @migrated-to academy-content-ui
 * ============================================================================
 */

import FormattedMessage from 'I18n/components/FormattedMessage';
import FormattedReactMessage from 'I18n/components/FormattedReactMessage';
import { Flex } from 'foundations-components/components/Flex';
import { ButtonWrapper } from 'foundations-components/transitional/components/ButtonWrapper';
import { Link } from 'foundations-components/transitional/components/Link';
import { HelpIcon } from 'foundations-components/transitional/components/HelpIcon';
import InlineFeedback from 'ai-components-ui-library/components/feedback/InlineFeedback';
import UsageTracker from '../../../utils/UsageTracker';
import { useSendAiFeedback } from '../queries/feedbackQueries.migrated';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const ExternalIcon = () => null;
const CompanionFooter = ({
  additionalButtons,
  borderBlockStartStyle = 'solid',
  contentType,
  correlationId = '',
  featureId,
  primaryContentId,
  trackingAction,
  noBorder = false,
  flush = false
}) => {
  const {
    sendAiFeedback
  } = useSendAiFeedback();
  const handleCustomFeedback = e => {
    // `ratingInteraction` expects `ratingScore` to be 1 | 2 | 3
    // `vote` is -1 | 1 so we are just adjusting here accordingly
    const amplitudeRatingScore = e.vote === 1 ? 2 : 1;
    const feedbackRatingScore = e.vote === 1 ? 'UPVOTE' : 'DOWNVOTE';
    if (correlationId && featureId) {
      void sendAiFeedback({
        variables: {
          correlationId,
          featureId,
          feedbackTags: e.options,
          feedbackText: e.feedbackMessage,
          ratingScore: feedbackRatingScore
        }
      });
    }
    UsageTracker.trackStandalone('Rating Interaction', {
      action: trackingAction,
      contentId: primaryContentId,
      contentType,
      feedbackText: e.feedbackMessage,
      ratingReason: e.options,
      ratingScore: amplitudeRatingScore,
      view: 'desktop'
    });
  };
  return /*#__PURE__*/_jsxs(Flex, {
    alignItems: "center",
    borderBlockStartColor: "border-core-subtle",
    borderBlockStartStyle: borderBlockStartStyle,
    borderBlockStartWidth: noBorder ? '0' : '100',
    justifyContent: "space-between",
    paddingBlock: "400",
    paddingInline: flush ? '0' : '700',
    children: [/*#__PURE__*/_jsx(ButtonWrapper, {
      horizontalGap: 16,
      marginInlineStart: flush ? '-200' : '0',
      children: /*#__PURE__*/_jsx(InlineFeedback, {
        messageId: correlationId,
        onNegativeFeedback: handleCustomFeedback,
        onPositiveFeedback: handleCustomFeedback,
        usageTracker: "WE HAVE CUSTOM TRACKING IN PLACE AND AI-EXTENSIBILITY TEAM IS AWARE"
      })
    }), /*#__PURE__*/_jsx(FormattedReactMessage, {
      message: "learningCenter.interactiveEducation.disclaimer",
      options: {
        link: /*#__PURE__*/_jsx(HelpIcon, {
          title: "",
          children: /*#__PURE__*/_jsx(Link, {
            ExternalIcon: ExternalIcon,
            external: true,
            href: "https://legal.hubspot.com/hubspot-beta-terms",
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              message: "learningCenter.interactiveEducation.seeTerms"
            })
          })
        })
      }
    }), additionalButtons]
  });
};

/**
 * @migrated-to academy-content-ui
 * @deprecated
 * This file has been migrated to academy-content-ui.
 * Canonical source: academy-content-ui/static/js/features/interactiveEducation/components/CompanionFooter.tsx
 *
 * This .migrated copy is retained only for LearningCenterUI consumers that
 * have not yet moved to academy-content-ui. All changes should be made in
 * academy-content-ui first, then synced here if still needed.
 *
 * This copy will be deleted when LearningCenterUI is shut down.
 */
export default CompanionFooter;